import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const iuiProcedure: ContentBlock<"module"> = {
  id: makeId("module-iui-procedure"),
  kind: "module",
  tags: ["both-partners", "treatment", "iui"],
  title: "IUI Procedure",
  subtitle: "Intrauterine insemination with washed sperm",
  icon: "💧",
  body: {
    duration: "1 day",
    category: "treatment",
    forWhom: "both",
    includes: [
      "Ovulation monitoring (ultrasound + LH tracking)",
      "Trigger shot timing if medicated cycle",
      "Sperm wash and preparation",
      "Intrauterine insemination procedure (~5 minutes)",
      "Post-wash sperm count report",
    ],
    trackableMarkers: [
      {
        name: "Post-wash sperm count",
        expectedToChange: false,
        expectation:
          "Total motile sperm after washing. >10 million total motile is ideal for IUI success.",
      },
      {
        name: "Follicle size at trigger",
        expectedToChange: true,
        expectation:
          "Lead follicle should be 18–24mm at time of trigger. Confirms ovulation timing.",
      },
    ],
    priceRange: { low: 300, high: 800 },
    currency: "USD",
    status: "coming-soon",
    steps: [
      {
        title: "Monitoring",
        description:
          "Ultrasound to confirm lead follicle maturity. Trigger shot if using medications.",
      },
      {
        title: "Sample preparation",
        description:
          "Sperm sample collected and washed to concentrate motile sperm. Takes ~1 hour.",
      },
      {
        title: "Insemination",
        description:
          "Thin catheter places washed sperm directly in the uterus. Quick and usually painless.",
      },
    ],
  },
  sources: [
    {
      title: "Intrauterine insemination: evidence-based guidelines",
      journal: "Human Reproduction Update",
      year: 2021,
      evidenceLevel: "meta-analysis",
    },
  ],
};

registerBlock(iuiProcedure);
